import React from "react";
import { Check, CheckCheck } from "lucide-react";

const ROLE_LABEL = { admin: "Admin", operatore: "Operatore", tecnico: "Tecnico", responsabile: "Capo squadra", supervisore: "Supervisore" };
export const roleLabel = (r) => ROLE_LABEL[r] || r || "";

const PALETTE = ["#1565C0", "#AD1457", "#6A1B9A", "#00838F", "#EF6C00", "#2E7D32", "#C62828", "#4E342E", "#283593", "#00695C"];
export const nameColor = (id) => PALETTE[[...String(id || "")].reduce((a, c) => a + c.charCodeAt(0), 0) % PALETTE.length];

const fmt = (iso) => { try { return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

export const readersOf = (m, members) => {
  const others = members.filter((u) => u.id !== m.user_id);
  const rb = m.read_by || {};
  return { read: others.filter((u) => rb[u.id]).map((u) => ({ ...u, at: rb[u.id] })), unread: others.filter((u) => !rb[u.id]), total: others.length };
};

export const ReadTicks = ({ m, members, mine, onOpen }) => {
  const { read, total } = readersOf(m, members);
  const all = total > 0 && read.length === total;
  const Icon = read.length ? CheckCheck : Check;
  return (
    <button type="button" onClick={onOpen} className="inline-flex items-center gap-0.5 hover:underline" title="Chi ha letto" data-testid={`chat-read-${m.id}`}>
      <Icon className="w-3.5 h-3.5" style={{ color: all ? "#4FC3F7" : mine ? "#ffffffb0" : "#94a3b8" }} />
      <span>{read.length}/{total}</span>
    </button>
  );
};

const Row = ({ u, right }) => (
  <div className="flex items-center gap-2 py-1.5">
    <span className="w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-bold text-white flex-shrink-0" style={{ background: nameColor(u.id) }}>{(u.name || "?").slice(0, 1).toUpperCase()}</span>
    <div className="flex-1 min-w-0">
      <div className="text-sm font-semibold truncate">{u.name}</div>
      <div className="text-[11px]" style={{ color: "var(--text-muted)" }}>{roleLabel(u.role)}</div>
    </div>
    {right}
  </div>
);

const Overlay = ({ title, onClose, children, testid }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,.4)" }} onClick={onClose}>
    <div className="bg-white rounded-xl w-full max-w-sm max-h-[80vh] overflow-auto p-4" onClick={(e) => e.stopPropagation()} data-testid={testid}>
      <div className="flex items-center mb-2">
        <div className="font-bold flex-1">{title}</div>
        <button onClick={onClose} className="text-sm px-2 py-1 rounded hover:bg-black/5" data-testid={`${testid}-close`}>Chiudi</button>
      </div>
      {children}
    </div>
  </div>
);

export const MembersDialog = ({ members, onClose }) => (
  <Overlay title={`Membri (${members.length})`} onClose={onClose} testid="chat-members-dialog">
    {members.map((u) => <Row key={u.id} u={u} />)}
  </Overlay>
);

export const ReadersDialog = ({ m, members, onClose }) => {
  const { read, unread } = readersOf(m, members);
  return (
    <Overlay title="Info messaggio" onClose={onClose} testid="chat-readers-dialog">
      <div className="text-[11px] font-semibold uppercase tracking-wider mt-1" style={{ color: "#0288D1" }}>Letto da ({read.length})</div>
      {read.length ? read.map((u) => <Row key={u.id} u={u} right={<span className="text-[11px]" style={{ color: "var(--text-muted)" }}>{fmt(u.at)}</span>} />)
        : <div className="text-xs py-1" style={{ color: "var(--text-muted)" }}>Nessuno</div>}
      <div className="text-[11px] font-semibold uppercase tracking-wider mt-3" style={{ color: "var(--text-muted)" }}>Non ancora letto ({unread.length})</div>
      {unread.map((u) => <Row key={u.id} u={u} />)}
    </Overlay>
  );
};
